module.exports = __webpack_public_path__ + "static/media/gamepad.0cc453db.png";